"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

require("source-map-support/register");

var _state = _interopRequireDefault(require("../../util/state"));

var _lodash = require("lodash");

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var listen = function listen(_ref) {
  var configService = _ref.configService,
      listenerService = _ref.listenerService;
  return function (next) {
    return function (args) {
      var hail = "".concat(configService.ps1).concat(configService.name);
      var matcher = new RegExp("^".concat((0, _lodash.escapeRegExp)(hail), "\\s"));
      listenerService.listen(matcher).pipe(function (context) {
        next(_objectSpread({}, args, {
          context: context,
          state: (0, _state.default)()
        })); // each downstream phase will share state
      });
    };
  };
};

var _default = listen;
exports.default = _default;